<div [ngStyle]="{'max-height': panelHeight  ? panelHeight + 'px' : 'inherit'}" class="social-history grey-two-background border print-element">
  <h6>Social History</h6>
  <app-textarea-widget
    [minRows]="1"
    [maxRows]="4"
    [textValue]="socialHistoryEntry?.entryText ? socialHistoryEntry.entryText : ''" (emitText)="saveSocialHistoryElement($event)"
  >
  </app-textarea-widget>
</div>
